import { useState, useCallback } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"

import { Damage } from "../types/lease"
import { axiosInstance } from "../helpers"
import { RootState } from "../store"

export const useDamages = () => {

    const leaseId = useSelector((state: RootState) => state.lease.selectedLease?.id)
    const [isLoading, setIsLoading] = useState(false)
    const [damages, setDamages] = useState<Damage[]>([])

    const getDamages = useCallback(async () => {
        if (!leaseId) {
            return
        }
        setIsLoading(true)
        try {
            const res = await axiosInstance.get('lease/tenant-damage/', {
                params: {
                    lease_id: leaseId,
                },
            })
            const damages: Damage[] = res.data
            setDamages(damages)
            setIsLoading(false)
            return damages
        } catch (error) {
            toast.error('Error getting damages')
            setIsLoading(false)
            return Promise.reject(error)
        }
    }, [leaseId])

    return { isLoading, damages, getDamages }
}